import React from 'react'

function Binary() {
    return (
        <span className='cs-exp-binary'>Binary</span>
    )
}

export { Binary }